<template>
  <div class="xcbf">
    <div class="xcbf-wrap">
      <div class="xcbf-top">
        <div class="logo"></div>
      </div>
      <div class="xcbf-title">小宝驿站</div>
      <div class="xcbf-content">
        <div class="content-item">驿站租用闲置空间，赚取积分收益</div>
        <div class="content-item">不影响网络冲浪、购物等体验</div>
        <div class="content-item">积分可兑换电话可或各类VIP会员</div>
      </div>
      <div class="xcbf-btns">
        <div class="xcbf-btn cancel-btn" @click="onCancelClick">取消</div>
        <div class="xcbf-btn open-btn" @click="onSureClick">开始赚积分</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isNotSupport"],
  data: function () {
    return {
      isOpening: false,
    };
  },
  methods: {
    onCancelClick: function () {
      this.$emit("onCloseClick");
    },
    onSureClick: function () {
      this.$emit("onSureClick");
    },
    onOpenClick: function () {
      let _that = this;
      _that.isOpening = true;
      setTimeout(function () {
        _that.$emit("onOpenClick");
      }, 3000);
    },
  },
  mounted: function () {
    let _that = this;
    _that.isOpening = false;
  },
};
</script>

<style lang="less" scoped>
.xcbf {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  //   background-color: rgba(0, 0, 0, 0.4);
  z-index: 9;
  .xcbf-wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 310px;
    height: 355px;
    margin-left: -155px;
    margin-top: -177px;
    background-color: #ffffff;
    box-shadow: 0px 8px 24px rgba(121, 121, 121, 0.16);
    border-radius: 16px;
    .xcbf-top {
      height: 93px;
      background-image: url(../../assets/components/tool/alert/byjs-bg.png);
      background-size: 100% 100%;
      position: relative;
      .logo {
        width: 121px;
        height: 97px;
        position: absolute;
        left: 40px;
        top: -20px;
        background-image: url(../../assets/components/tool/alert/byjs-icon.png);
        background-size: 100% 100%;
      }
    }
    .xcbf-title {
      font-weight: 700;
      font-size: 20px;
      line-height: 26px;
      text-align: center;
      color: #1a1a1a;
      margin-top: 24px;
      margin-bottom: 20px;
    }
    .xcbf-content {
      padding-left: 35px;
      .content-item {
        background-image: url(../../assets/components/tool/alert/content-point.png);
        background-size: 6px 6px;
        background-repeat: no-repeat;
        background-position: left center;
        margin-bottom: 8px;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        padding-left: 15px;
      }
    }
    .xcbf-btns {
      text-align: center;
      margin-top: 45px;
      .xcbf-btn {
        width: 128px;
        height: 42px;
        line-height: 42px;
        margin: 0 6px;
        display: inline-block;
        vertical-align: top;
        background: #ededed;
        border-radius: 120px;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }
      .xcbf-btn:hover {
        cursor: pointer;
        opacity: 0.9;
      }
      .xcbf-btn.open-btn.nosupport-btn {
        background: #999999;
      }
      .xcbf-btn.open-btn {
        background: linear-gradient(173.42deg, #133977 4.2%, #103570 132.7%);
        background: linear-gradient(154deg, #695eff 0%, #3931c6 96.01%);
        box-shadow: 0px 2px 4px rgba(93, 95, 106, 0.24);
        border-radius: 48px;
        color: #ffffff;
        .progress {
          display: none;
        }
      }
      .xcbf-btn.open-btn.open-btn-ing {
        position: relative;
        overflow: hidden;
        .progress {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: #7592d9;
          display: block;
          z-index: 2;
          animation: opening 3s;
        }
        @keyframes opening {
          from {
            width: 0;
          }
          to {
            width: 100%;
          }
        }
        .value {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          color: #ffffff;
          z-index: 3;
        }
      }
    }
  }
}
</style>
